import LayoutSize from "./LayoutSize";

export default class LayoutBody {
  id: number = 0;
  image: string = "";
  name: string = "";
  icon: string = "";
  price: string = "";
  dimensions: string | null = null;
  range_price_percentage: string = "";
  code: string = "";
  is_draft: boolean = false;
  layout_sizes: LayoutSize[];

  constructor(data: Partial<LayoutBody>) {
    Object.assign(this, data);
    this.layout_sizes =
      data.layout_sizes?.map((size) => new LayoutSize(size)) || [];
  }
}
